<template>
  <!-- 로딩화면 추가 - 2020-03-02 김진희 -->
  <v-card>
    <v-card-title class="p-0 font-weight-bold py-1">
      <div class="d-flex align-center">
        <span class="pl-5">HiSmart 3.0 - CCTV Streaming - {{siteId}}</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeCctvPopup">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="d-flex justify-center" v-if="showLoading">
          <v-progress-circular
            :rotate="360"
            :size="150"
            :width="15"
            :value="loadingTime"
            color="primary"
          >
            <span class="text-h5 font-weight-bold">{{ loadingTime.toFixed(0) }}</span>%
          </v-progress-circular>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-show="!showLoading">
      <v-row>
        <v-col
          v-for="(item,index) in cctvList"
          :key="index"
          class="d-flex flex-column align-center"
          @click="connectCCTV(item.id,index)"
        >
          <v-img max-width="100" :src="item.src">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <span>CCTV #{{index + 1}}</span>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col>{{cctvSelect !== -1 ? 'Playing ... CCTV #'+(cctvSelect+1) : ''}}</v-col>
      </v-row>
      <v-row>
        <v-col>
          <video
            :id="videoId"
            style="width:100%;height:52vw; max-height: 350px"
            class="video-js vjs-default-skin vjs-big-play-centered"
            controls
            preload="auto"
            muted
            autoplay
            playsinline
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
/*
2020-02-26 수정사항 - 김진희

1. 파일을 @api/cctv/cctv.js 와 분리함
2. 로드 시에만 네트워크 트래픽 걸리도록 로드 시 CCTV 연결, 종료 시 CCTV 연결 해제
3. limitMinute 변수로 CCTV 연결 시간 제한(제한시간 경과 후 창 종료)

* 2020-02-17 수정사항 - 김진희
1. change() 메서드 오류 고치고, mounted() 메서드에서 사용 (코드 정리)
2. 플레이어 재생하면 재생한 것만 화면에 보이고 창을 채우기 (init_page())
3. 플레이어 재생 중 일시정지하면 플레이어 배치를 원복함

이후 추가된 기능:
CCTV 창을 늘리거나 줄이면 CCTV 화면도 비례해서 커지거나 작아지게 하여
CCTV 이용 고객에게 편의성 제공
*/
import envs from '@/envs'
import {
  connect,
  disconnect,
  disconnectAll,
  getImageUrl
} from '@/api/cctv/cctvConnector'
import videojs from 'video.js'
import Message from '@/utils/message'
import { isMobile } from '@/utils/check'

const BACKGROUND_COLOR = 'black'
const LOADING_COLOR = 'rgb(233,233,233)'
const PLAYER_ALL_STOPPED = -1

let player = {}
let idx = 0

export default {
  name: 'cctvPopup',
  props: {
    cctvCnt: {
      type: Number
    },
    siteId: {
      type: String
    }
  },
  data() {
    return {
      playUrl: '',
      streaming: false,
      showLoading: true,
      // cctvCnt: 1,
      cctvList: [],
      interval: '',
      ACTUAL_LOADING_TIME: 9,
      LIMIT_MINUTE: 20,
      LOADING_GAGE_TIME: 8, // 다음은 로딩화면 원 그림에 대한 설정
      LOADING_TIME_DIVISION: 9, // 걸리는 시간보다 1만큼 더 큰 단위로 나누면 자연스러운 듯
      LOADING_TIME_INTERVAL: 1,
      loadingTime: 0,
      WowzaAddress: envs.WowzaAddress,
      player: '',
      errorOccured: false, // 화면 로딩 중이거나 시청 중 오류가 발생한 경우
      idxRunningPlayer: PLAYER_ALL_STOPPED,
      confirmationMessage: '팝업 종료',
      allDisconnected: true,
      loading: true,
      loadingCircleColor: { gradient: ['red', 'green', 'blue'] },
      cctvSelect: -1
    }
  },
  components: {},
  created() {
    // this.LOADING_TIME_INTERVAL = this.LOADING_GAGE_TIME / this.LOADING_TIME_DIVISION // 그림이 변하는 간격
    // this.loadingTime = this.LOADING_TIME_INTERVAL // 그림 변하는 시간 고려해서 한 스텝 앞서게 함
    // this.checkOpenerClosedAndDisconnectAll()
    if (
      this.$route.query.siteId !== undefined &&
      this.$route.query.siteId !== ''
    ) {
      this.siteId = this.$route.query.siteId
    }
    if (
      this.$route.query.cctvCnt !== undefined &&
      this.$route.query.cctvCnt !== ''
    ) {
      this.cctvCnt = this.$route.query.cctvCnt
    }

    setTimeout(() => {
      this.closeCctvPopup()
    }, this.LIMIT_MINUTE * 60 * 1000)
  },
  mounted() {
    // this.waitForLoading()
    this.startInterval()
    this.makePlayers()
  },
  computed: {
    videoId() {
      return 'video_' + idx
    }
  },
  methods: {
    closeCctvPopup() {
      // if (isMobile()) {
      //   this.$router.go(-1)
      // } else {
      this.$emit('closeDetailPop')
      // }
    },
    catchError(cctvId) {
      setTimeout(() => {
        if (this.errorOccured && !this.streaming) {
          disconnectAll()
        }
      }, 10000)
    },
    connectCCTV(cctvId, index) {
      if (index === -1) {
        return
      }
      if (this.cctvSelect !== index) {
        disconnect(this.siteId + '_' + this.cctvSelect)
      }
      if (player.src === undefined) {
        this.readyPlayer()
      }
      this.cctvSelect = index
      this.$nextTick(() => {
        connect(cctvId)
        this.playCctv(cctvId)
        this.catchError(cctvId)
      })
    },
    startInterval() {
      this.showLoading = true
      this.interval = setInterval(() => {
        let random = Math.random() * 10 + 1
        if (random + this.loadingTime > 100) {
          this.loadingTime = 100
          this.stopInterval()
        } else {
          this.loadingTime += random
        }
      }, 1000)
    },
    stopInterval() {
      clearInterval(this.interval)
      if (this.loadingTime === 100) {
        setTimeout(() => {
          this.showLoading = false
        }, 1000)
      }
    },
    makePlayers() {
      let count = this.cctvCnt
      let playerWidth = 500 // this.calcWidth() // 플레이어width
      let playerHeight = 500 // this.calcHeight() // 플레이어height
      // this.appendTags(playerWidth, playerHeight)
      for (let idx = 0; idx < count; idx++) {
        // 다음 두 메서드는 appendTags 를 실행한 후에야 제대로 실행 가능함
        // player[idx] = this.readyPlayer(idx, playerWidth, playerHeight)
        this.loadThumbnail(idx, playerWidth, playerHeight)
      }
    },
    readyPlayer() {
      // let players = []
      player = videojs(this.videoId, {
        autoplay: true,
        muted: true,
        controls: true,
        preload: 'auto',
        playsinline: true
      })
      console.log(this.videoId)

      // 정지 시 원복 - 2020-02-17 김진희
      player.on('pause', function() {
        // 로딩이 안 되었거나 에러발생 이후로 정지된 경우 이벤트 없음
        if (this.errorOccured) return
        disconnect(this.siteId + '_' + this.cctvSelect)
        // this.changeAllComponentSize()
      }) // 익명 함수를 CctvPopup.vue에 묶음

      // 에러 시 매 2초마다 재시도
      player.on(
        'error',
        function() {
          this.errorOccured = true
          this.showLoading = false
        } // 익명 함수를 CctvPopup.vue에 묶음
      )
    },
    playCctv(cctvId) {
      let url = envs.WowzaAddress + '/live/' + cctvId + '.stream/playlist.m3u8'
      this.playUrl = url
      this.errorOccured = false

      if (!player.src) {
        this.readyPlayer()
      }

      player.src({ src: url })
      // player.currentTime(0)
      // player.reset()
      // this.playUrl = url
      // // IE 재생 개선
      // setTimeout(() => {
      //   if (this.errorOccured === false) {
      //     console.log('play')
      //     player.play()
      //     this.showLoading = false
      //     // if (isTablet()) {
      //     //   console.log('aaa')
      //     //   $('#player_html5_api').width('540px').height('350px')
      //     // }
      //     this.streaming = true
      //   }
      // }, 2000)
      player.ready(() => {
        player.play().then(() => {
          this.streaming = true
          this.showLoading = false
        }).catch(e => {
          this.streaming = false
          this.showLoading = false
          console.error('Playback failed:', e)
        })
      })
    },
    loadThumbnail(idx, width, height) {
      // let imgId = 'thumbnail' + idx
      // let thumbnail = document.getElementById(imgId)
      let cctvId = this.siteId + '_' + (idx + 1)
      let url = getImageUrl(cctvId, width, height)
      connect(cctvId)
      this.cctvList.push({
        id: cctvId,
        src: url
      })
    },
    // 로딩화면 관련 함수 - 2020-03-02 김진희
    waitForLoading() {
      setTimeout(() => {
        this.loading = false
        $('body').css('background', BACKGROUND_COLOR) // 로딩 완료 후 본 배경
        this.loadingTime = 0
      }, (this.LOADING_GAGE_TIME + this.LOADING_TIME_INTERVAL) * 1000) // 최종 로딩시간 설정
    },
    checkOpenerClosedAndDisconnectAll() {
      setTimeout(() => {
        // console.log(cctvPopup.parent)
        if (opener === null) {
          // alert('메인창이 종료되었습니다.')
          this.disconnectAllAndDelayClose()
        } else {
          this.checkOpenerClosedAndDisconnectAll()
        }
      }, 1000)
    },
    disconnectAllAndDelayClose() {
      this.$emit.close()
      // 바로 종료시키면 제대로 반영 안 되므로 시간차를 둠
    },
    changeAllComponentSize() {
      if (this.loading) {
        // this.locateLoading()
      } else {
        let count = this.cctvCnt

        let prefixArray = ['#player_with_thumbnail', '#player', '#thumbnail']

        for (let prefix of prefixArray) {
          if (this.idxRunningPlayer === PLAYER_ALL_STOPPED) {
            for (let i = 0; i < count; i++) {
              $(prefix + i).width(this.calcWidth())
              $(prefix + i).height(this.calcHeight() - 20)
            }
          } else {
            let i = this.idxRunningPlayer
            $(prefix + i).width(window.innerWidth)
            $(prefix + i).height(this.getFullHeight())
          }
        }
      }
    },
    getFullHeight() {
      return window.innerHeight - 40
    },
    // CCTV 개수에 따라 크기 결정(최대 9개까지만)
    calcWidth() {
      let count = this.cctvCnt
      return count > 1
        ? count < 5
          ? window.innerWidth / 2
          : window.innerWidth / 3
        : window.innerWidth
    },
    calcHeight() {
      let count = this.cctvCnt
      let fullHeight = this.getFullHeight()

      return count > 1
        ? count < 7
          ? fullHeight / 2
          : fullHeight / 3
        : fullHeight
    }
  },
  beforeDestroy() {
    idx++
    disconnectAll(this.siteId, this.cctvCnt)
    player.off()
    videojs(this.videoId).dispose()
    player = {}
    // player.destroy()
  }
}
</script>
